<template>
  <div v-if="buttons.length" class="preset-filter-buttons" role="group" aria-label="Filter buttons">
    <button
      v-for="button in buttons"
      :key="button.id"
      type="button"
      class="preset-filter-btn"
      :class="{ active: isActive(button.id) }"
      :aria-pressed="isActive(button.id) ? 'true' : 'false'"
      @click="$emit('toggle', button.id)"
    >{{ button.label }}</button>
  </div>
</template>

<script>
export default {
  name: 'PresetFilterButtons',
  props: {
    buttons: { type: Array, default: () => [] },
    activeIds: { type: Array, default: () => [] }
  },
  emits: ['toggle'],
  methods: {
    isActive (id) {
      return this.activeIds.includes(id)
    }
  }
}
</script>

<style>
.preset-filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.preset-filter-btn {
  border: 1px solid #ced4da;
  background: #fff;
  color: #212529;
  border-radius: 999px;
  padding: 4px 14px;
  font-size: 0.9rem;
  line-height: 1.4;
  cursor: pointer;
}

.preset-filter-btn:hover {
  border-color: #212529;
}

.preset-filter-btn.active {
  background: #212529;
  border-color: #212529;
  color: #fff;
}

.preset-filter-btn:focus-visible {
  outline: 2px solid #212529;
  outline-offset: 2px;
}
</style>
